import { InputAdornment, OutlinedInput } from "@mui/material";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import styled from "styled-components";


const Container = styled.div`
  position: relative;
  & .MuiOutlinedInput-root {
    height: 38px;
    border-radius: 8px;
    padding: 12px 0px 12px 8px;
  }

  & .MuiOutlinedInput-input::placeholder {
    color: #000;
    opacity: 1;
    font-size: 14px;
    font-family: Manrope;
  }

  & .MuiOutlinedInput-input {
    color: #000;
    opacity: 1;
    font-size: 14px;
    font-family: Manrope;
  }
  
  & .MuiOutlinedInput-notchedOutline {
    /* border: 1px solid white; */
  }

  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

const ErrorMessage = styled.span`
  position: absolute;
  font-size: 12px;
  font-weight: 500;
  color: red;
  height: ${(props) => props.error};
  transition: 300ms;
`;

export const InputAmmount = ({
  errorMessage,
  name,
  control,
  placeholder,
  max,
  maxLength,
  onChangeHandler,
  forceValue
}) => {
    
  return (
    <Container>
      <Controller
        name={name}
        control={control}
        render={({ field, field: { onChange, name, value } }) => (
          <NumericFormat
            {...field}
            allowLeadingZeros
            thousandSeparator=","
            customInput={OutlinedInput}
            size="small"
            placeholder={placeholder}
            name={name}
            value={forceValue ? forceValue !== "0.00" ? forceValue : value : value }
            onChange={(value) => {
              onChange(value);
              onChangeHandler(value, name);
            }}
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
          />
        )}
        rules={{ required: true, min: 0, max, maxLength }}
      />
      <ErrorMessage>
        {errorMessage === "required" ? "Campo obligatorio" : ""}
        {errorMessage === "min" ? "Ingresa un valor correcto" : ""}
        {errorMessage === "max" ? "Ingresa un valor correcto" : ""}
        {errorMessage === "maxLength" ? "Ingresa un valor correcto" : ""}
      </ErrorMessage>
    </Container>
  );
};
